import { forwardRef, ComponentRef } from 'react';
import { AutoComplete, Empty, Spin } from 'antd';
import { Input } from 'components';
import { IAutocompleteProps } from './Autocomplete.types';

import './Autocomplete.styles.scss';

const NotFoundContent = ({ loading }: { loading: boolean }) => {
  if (loading) {
    return (
      <div className="np-autocomplete__not-found">
        <Spin />
      </div>
    );
  }

  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
};

const Autocomplete = forwardRef<ComponentRef<typeof Input>, IAutocompleteProps>(
  ({ inputProps = {}, loading, className, size, ...props }: IAutocompleteProps, ref) => {
    return (
      <AutoComplete
        className={`np-autocomplete ${className}`}
        size={size}
        notFoundContent={<NotFoundContent loading={loading} />}
        {...props}
      >
        <Input ref={ref} size={size} {...inputProps} />
      </AutoComplete>
    );
  },
);

export default Autocomplete;
